import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const First500Cancel = lazy(() => import("@/pages/First500Cancel"));

export const Route = createFileRoute("/first-500/cancel")({
  component: First500Cancel,
});
